import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Swiper as SwiperType } from 'swiper/types'

import { CustomerLoyaltyCard } from '../../CustomerLoyaltyCard/CustomerLoyaltyCard'
import { LoyaltyCardSliderContainer } from '../../CustomerLoyaltyCard/CustomerLoyaltyCard.styles'

import {
  ArrowContainer,
  HeaderContainer,
} from '../../ActiveOrdersSlider/ActiveOrdersSlider.styles'
import { IconButton } from '../../Button/IconButton'
import { Carousel } from '../../Carousel'
import { useMarketplace } from '@src/hooks/useMarketplace'
import { CustomerDetailsAndAddresses_customerDetails_loyaltyCards } from '@src/hooks/sharedQueries/useCustomerDetailsAndAddressesQuery/queries/__generated__/CustomerDetailsAndAddresses'
import { StyledAccountSectionNavButton } from '../AccountMain/AccountMain.styles'
import { MainRouteName } from '../../../hooks/useAccountRouter'

export const CustomerLoyaltyCardSlider: React.FC<{
  allLoyaltyCards: CustomerDetailsAndAddresses_customerDetails_loyaltyCards[]
  stampedLoyaltyCards: CustomerDetailsAndAddresses_customerDetails_loyaltyCards[]
}> = ({ allLoyaltyCards, stampedLoyaltyCards }) => {
  const { t } = useTranslation('customerLoyaltyCard')
  const [currentIndex, setCurrentIndex] = useState(0)
  const marketplace = useMarketplace()
  const [loyaltyCardSwiperInstance, setLoyaltyCardSwiperInstance] =
    useState<SwiperType | null>(null)

  const scrollToNextCard = () => {
    const indexToScrollTo = currentIndex + 1
    setCurrentIndex(indexToScrollTo)
    loyaltyCardSwiperInstance?.slideTo(indexToScrollTo, 500)
  }

  const scrollToPreviousCard = () => {
    const indexToScrollTo = currentIndex - 1
    setCurrentIndex(indexToScrollTo)
    loyaltyCardSwiperInstance?.slideTo(indexToScrollTo, 500)
  }

  return (
    <>
      {allLoyaltyCards.length > 0 && (
        <HeaderContainer>
          <StyledAccountSectionNavButton
            route={{ mainRouteName: MainRouteName.LOYALTY_LIST }}
            dataTestId="menu-drawer-link-"
          >
            {t('my_loyalty_cards', {
              chosenHeaderName:
                marketplace?.loyaltyCardSectionHeader ?? 'Loyalty Card',
            })}
          </StyledAccountSectionNavButton>
          {stampedLoyaltyCards.length > 1 && (
            <ArrowContainer>
              <IconButton
                disabled={currentIndex === 0}
                onClick={() => {
                  if (currentIndex > 0) {
                    scrollToPreviousCard()
                  }
                }}
                size={32}
                icon={'caretLeft'}
                alt={t('left')}
              />
              <IconButton
                disabled={currentIndex === stampedLoyaltyCards.length - 1}
                onClick={() => {
                  if (currentIndex !== stampedLoyaltyCards.length - 1) {
                    scrollToNextCard()
                  }
                }}
                size={32}
                icon={'caretRight'}
                alt={t('right')}
              />
            </ArrowContainer>
          )}
        </HeaderContainer>
      )}
      {stampedLoyaltyCards.length > 0 && (
        <LoyaltyCardSliderContainer>
          <Carousel
            isAccount={true}
            isFirstCard={false}
            allowTouchMove={false}
            setSwiperInstance={setLoyaltyCardSwiperInstance}
            slides={stampedLoyaltyCards.map((loyaltyCard, index) => {
              return (
                <CustomerLoyaltyCard
                  loyaltyCard={loyaltyCard}
                  key={`${loyaltyCard.id}`}
                  isFinalCard={index === stampedLoyaltyCards.length - 1}
                  isAccountsSection
                />
              )
            })}
          />
        </LoyaltyCardSliderContainer>
      )}
    </>
  )
}
